module.exports = __webpack_public_path__ + "85a11c3a4c4434f78a215c6a75aa0458.MP3";